import { ExceptionMessage } from '../types/type';

const getErrorDescription = (
  data: { message: string },
  status: number,
): string => {
  if (data.message !== null) {
    return data.message !== 'GENERAL'
      ? data.message
      : `${status} ${'-'} Error al conectarse al servidor`;
  }
  return `${status} ${data}`;
};

export const parseApiError = (error: ExceptionMessage): ExceptionMessage => {
  try {
    const parsedError = JSON.parse(JSON.stringify(error));
    console.error(parsedError);
    const {
      response: { data, status },
    } = parsedError;
    return {
      status,
      message: 'Error',
      description: getErrorDescription(data, status),
      duration: 0,
    };
  } catch (ex) {
    return {
      status: 500,
      message: 'Error',
      description: 'Error de conexión!',
      duration: 0,
    };
  }
};
